import   _               from 'lodash';
import   Immutable       from 'immutable';
import { NotFoundError } from 'lib/errors';

export default class EntitySpace {
  constructor(maps) {
    this.maps = maps;
  }

  static for(model, entities) {
    const map  = new Immutable.OrderedMap(entities.map(entity => [entity.pk, entity]));
    const maps = (new Immutable.Map).set(model, map);

    return new (this)(maps);
  }

  mapFor(model) {
    return this.maps.get(model) ?? throw new Error(`no secondary map for ${model.name}`);
  }

  safeMapFor(model) {
    return this.maps.get(model) ?? new Immutable.OrderedMap;
  }

  mapForOrNull(model) {
    return this.maps.get(model);
  }

  entityFor(model, pk) {
    return this.maps.getIn([model, pk]) ?? throw new NotFoundError(model);
  }

  safeEntityFor(model, pk) {
    return this.maps.getIn([model, pk]);
  }

  merge(other) {
    return new this.constructor(this.maps.mergeDeep(other.maps));
  }

  add(entity) {
    return new this.constructor(this.maps.setIn([entity.constructor, entity.pk], entity));
  }

  update(entity) {
    return new this.constructor(this.maps.setIn([entity.constructor, entity.pk], entity));
  }

  remove(entity) {
    return new this.constructor(this.maps.deleteIn([entity.constructor, entity.pk]));
  }
}
